// Module
var code = "<span class=\"entities-enumeration\" ng-repeat=\"entity in vm.entities\"> <a ng-if=\"vm.url\" ng-href=\"{{ vm.url + '/' + entity.id }}\" ng-click=\"vm.navigate()\">{{entity.name}}</a> <span ng-if=\"!vm.url\">{{entity.name}}</span> <span ng-if=\"!$last && vm.entities.length > 0\">,&nbsp;</span> </span> ";
// Exports
module.exports = code;